document.querySelectorAll('.js-form-reset').forEach(($target) => {
  $target.addEventListener('click', (event) => {
    // Prevent default event
    event.preventDefault();

    // Find parent element by class
    function findAncestor(el, klass) {
      let $el = el.parentNode;

      while ($el && !$el.classList.contains(klass)) $el = $el.parentNode;
      return $el;
    }

    // Current target
    const $currentTarget = event.currentTarget;

    // Find parent form
    const $form = findAncestor($currentTarget, 'form');

    // Find inputs
    const $inputs = $form.querySelectorAll('input:not([type=submit]), textarea, select');

    // Reset inputs
    $inputs.forEach(($input) => {
      const $el = $input;

      $el.value = '';
      $el.checked = false;
      $el.selectedIndex = 0;
    });
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/shared/form-reset.js